import { useSyncExternalStore } from "react";
import { addPageScrollListener, getPageScrollTop } from "./app-scroll.ts";

export function useScrolledPastTop(offset = 1) {
    return useSyncExternalStore(
        (listener) => {
            let frame: number | null = null;

            function handleScroll() {
                if (frame !== null) return;
                frame = window.requestAnimationFrame(() => {
                    frame = null;
                    listener();
                });
            }

            const unsubscribe = addPageScrollListener(handleScroll);
            return () => {
                if (frame !== null) window.cancelAnimationFrame(frame);
                unsubscribe();
            };
        },
        () => getPageScrollTop() > offset,
        () => false,
    );
}
